import React from "react"
import styled from "styled-components"
import { useRouter } from "next/router"

import Link from "next/link"
import UpArrow from "~/components/svg/UpArrow"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
`

const Header = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  border: none;
  margin: 0;
  padding: 12px 0;
  background: none;
  outline: none;
  align-items: center;
  color: ${(props) =>
    props.isOpen ? props.theme.colors.primary : props.theme.colors.text.header};
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 1em;
  line-height: 1.375em;
  cursor: pointer;
  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.primary};
  }
`

const Text = styled.div`
  flex-grow: 1;
  text-align: left;
  word-wrap: break-word;
  flex-shrink: 1;
`

const Icon = styled.div`
  flex-shrink: 0;
  border: solid 1px ${(props) => props.theme.colors.ui.inputBorder};
  border-radius: 50%;
  width: 21px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
  margin: 0 0 0 10px;
  transition: all 0.5s ease;
  transform: rotate(${(props) => (props.isOpen ? 180 : 0)}deg);
`

const Body = styled.div`
  max-height: ${(props) => (props.isOpen ? 700 : 0)}px;
  overflow: hidden;
  ${"" /* transition: all 0.5s ease; */}
`

const BodyText = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 1em;
  color: ${(props) => props.theme.colors.text.label};
  line-height: 1.6em;
  padding: 0 0 25px 0;
  a {
    word-break: break-word;
  }
`

const Item = ({ open, title, text, slug }) => {
  const router = useRouter()
  return (
    <Container id={open ? "answer" : undefined}>
      <Link
        href={`/faq/[category]/${slug}#answer`}
        as={`/faq/${router.query.category}/${slug}#answer`}
        passHref
        scroll={false}
        replace
      >
        <Header isOpen={open}>
          <Text>{title}</Text>
          <Icon isOpen={open}>
            <UpArrow />
          </Icon>
        </Header>
      </Link>
      <Body isOpen={open}>
        <BodyText>{text}</BodyText>
      </Body>
    </Container>
  )
}

export default Item
